import { useEffect, useRef, useState } from "react";
import { MdOutlinePause, MdPlayArrow, MdOutlineReplay } from "react-icons/md";

import Player from "@vimeo/player";
let player;

function VirtualPTVideo({ mobile = true, controls = null, setupVideoControls = null, goToScheduler }) {
    const iframeRef = useRef(null);
    const [playerStatus, setPlayerStatus] = useState("playing"); // playing, paused, stopped

    const PlayVideo = async () => {
        player = new Player(iframeRef.current);
        player.setQuality("1080p");
        player.ready().then(() => {
            // player?.play?.();
        });
        player.on("timeupdate", (time) => {});

        player.on("ended", () => {
            // controls.next();
            // controls.play();
            setPlayerStatus("stopped");
        });

        player.on("play", () => {
            controls && controls.start();
        });

        setupVideoControls &&
            setupVideoControls({
                play: Play,
                pause: Pause,
                restart: Restart,
            });
    };

    const Play = () => {
        player.play();
        setPlayerStatus("playing");
    };

    const Pause = () => {
        player.pause();
        setPlayerStatus("paused");
    };

    const Restart = () => {
        setPlayerStatus("playing");
        player.setCurrentTime(0);
        player.play();
    };

    useEffect(() => {
        PlayVideo();
    }, []);

    return (
        <div id="v-pt-slider-1" className="v-pt-slides">
            <div id="v-pt-s1-iframe-overlay" />
            <iframe ref={iframeRef} className="home-page iframe-player" title={"Temporary"} src={`https://player.vimeo.com/video/${mobile ? "932532403" : "925446703"}?pip=1&controls=0&muted=${!controls ? 0 : 0}&autoplay=1&quality=1080p`} allow="picture-in-picture; autoplay" data-ready allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" responsive="true" />

            {playerStatus === "playing" && (
                <MdOutlinePause
                    className="v-pt-s1-video-control"
                    id="v-pt-s-pause"
                    onClick={() => {
                        setPlayerStatus("paused");
                        Pause();
                    }}
                />
            )}
            {playerStatus === "paused" && (
                <MdPlayArrow
                    className="v-pt-s1-video-control"
                    id="v-pt-s-play"
                    onClick={() => {
                        setPlayerStatus("playing");
                        Play();
                    }}
                />
            )}
            {playerStatus === "stopped" && (
                <MdOutlineReplay
                    className="v-pt-s1-video-control"
                    id="v-pt-s-play"
                    onClick={() => {
                        setPlayerStatus("playing");
                        Restart();
                    }}
                />
            )}

        </div>
    );
}

export default VirtualPTVideo;
